import type { Modifier } from "@dnd-kit/core";
import { getEventCoordinates } from "@dnd-kit/utilities";

type PinPreviewArgs = Pick<
    Parameters<Modifier>[0],
    "activatorEvent" | "activeNodeRect" | "transform"
>;

/**
 * Drag overlay modifier that starts the preview at the pointer rather than at
 * the dragged element's top-left, which for a whole row can be far from where
 * it was pressed.
 */
export const pinPreviewToPointer = ({
    activatorEvent,
    activeNodeRect,
    transform,
}: PinPreviewArgs) => {
    const pointer = activatorEvent ? getEventCoordinates(activatorEvent) : null;
    if (!pointer || !activeNodeRect) {
        return transform;
    }
    return {
        ...transform,
        x: transform.x + pointer.x - activeNodeRect.left,
        y: transform.y + pointer.y - activeNodeRect.top,
    };
};
